import { createStyleSheet } from '@shared-ui/theme'
import { rf, rh, rw } from '@shared-ui/theme/scale'
import { Platform } from 'react-native'

export const useCreateStyles = createStyleSheet((theme, { safe }) => ({
  overlay: { flex: 1, justifyContent: 'flex-end' },
  overlayDesktop: { justifyContent: 'center', paddingHorizontal: rw(24) },
  backdrop: { position: 'absolute', inset: 0, backgroundColor: theme.COLOR_NEUTRAL_950, opacity: 0.2 },
  sheet: {
    ...(Platform.OS === 'web'
      ? ({ width: '100%', maxWidth: Math.min(rw(480), 480), alignSelf: 'center' } as const)
      : {}),
    flexGrow: 0,
    maxHeight: '90%',
    borderTopLeftRadius: rw(24),
    borderTopRightRadius: rw(24),
    backgroundColor: theme.COLOR_BG_BASE,
  },
  sheetDesktop: { borderRadius: rw(24) },
  content: { paddingHorizontal: rw(24), paddingTop: rh(32), paddingBottom: rh(24) + Math.max(safe.bottom, rh(34)) },
  close: { position: 'absolute', right: rw(16), top: rh(16), padding: rw(8), zIndex: 1 },
  title: { fontSize: rf(28), lineHeight: rh(32.2), letterSpacing: rw(-0.56), paddingRight: rw(40) },
  description: { fontSize: rf(16), lineHeight: rh(22.4), color: theme.COLOR_TEXT_SECONDARY },
  error: { fontSize: rf(16), lineHeight: rh(22.4), color: theme.COLOR_TEXT_CRITICAL },
  button: { borderRadius: rw(999) },
}))
